import React, { FC, useContext, useMemo } from 'react';

import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { TEXTAREA_MAX_LENGTH } from '@constants/enrollmentList/enrollmentList.constant';
import { INPUT_TYPES } from '@constants/inputs/inputTypes';
import Form from '@lib/wrappers/Form';
import UniversalInput from '@lib/wrappers/UniversalInput';
import { changeFieldValue, validateTextArea } from '../common/enrollmentUtils';
import { AddOrChangeTxnFormContext } from '../context/AddOrChangeTxnProvider';

export const StyledTextAreaContainer = styled.div`
    .gi-textarea__label {
        width: 2px !important;
    }
    .gi-textarea__input {
        flex: 1;
        width: 100%;
        height: 12rem !important;
    }
    .gi-textarea {
        display: flex;
        width: 100%;
        text-align: left;
        padding-left: 0;
        flex-direction: row;
        flex-wrap: nowrap;
        color: ${({ theme }) => theme.primaryMain};
    }
`;

export const StyledCharacterCounter = styled.div`
    margin-top: 0.5rem;
`;

const AddOrChangeReasonField: FC = () => {
    const intl = useIntl();
    const {
        watch,
        formState: { errors },
        setValue,
    } = useContext(AddOrChangeTxnFormContext);
    const values = watch();

    const maxChars = useMemo(
        () => TEXTAREA_MAX_LENGTH.MAX - values?.addOrChangeComment?.length,
        [values?.addOrChangeComment],
    );

    const handleChange = (field, inputValue: string) => {
        const value = validateTextArea(inputValue);
        changeFieldValue(setValue, field, value);
    };

    return (
        <Form formName={'enrollment'}>
            <StyledTextAreaContainer data-testid="textarea-container">
                <UniversalInput
                    label={{
                        isLabelVisible: true,
                    }}
                    inputData={{
                        type: INPUT_TYPES.TEXTAREA,
                        liClass: ['text-left'],
                        currentData: values,
                        name: 'addOrChangeComment',
                        value: values.addOrChangeComment,
                        isInputRequired: true,
                        placeholder: intl.formatMessage({
                            id: 'member.enrollment_list.premiumhistory.txnChangeReason.placholder',
                        }),
                        rows: 10,
                    }}
                    errorClasses={['margin-l-0']}
                    inputActions={{
                        onFieldChange: ({ addOrChangeComment }) => {
                            handleChange('addOrChangeComment', addOrChangeComment);
                        },
                    }}
                />
            </StyledTextAreaContainer>
            <StyledCharacterCounter data-testid="character-counter">
                {maxChars} {intl.formatMessage({ id: 'member.enrollment_list.premiumhistory.left' })}
            </StyledCharacterCounter>
        </Form>
    );
};

export default AddOrChangeReasonField;
